/* 时间轴归类 */
function transDate(n) {
    var date = new Date(n);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return (Y + M + D)
}

function timestampFormat(timestamp, top = null) {
    function zeroize(num) {
        return (String(num).length == 1 ? '0' : '') + num;
    }

    var curTimestamp = parseInt(new Date().getTime()); //当前时间戳
    var timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数

    var curDate = new Date(curTimestamp); // 当前时间日期对象
    var tmDate = new Date(timestamp); // 参数时间戳转换成的日期对象

    var Y = tmDate.getFullYear(),
        m = tmDate.getMonth() + 1,
        d = tmDate.getDate();
    var H = tmDate.getHours(),
        i = tmDate.getMinutes(),
        s = tmDate.getSeconds();

    if (top) {
        if (timestampDiff < 60) { // 一分钟以内
            return "刚刚";
        } else if (timestampDiff < 3600) { // 一小时前之内
            return Math.floor(timestampDiff / 60) + "分钟前";
        } else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
            return '今天：' + Y + '-' + zeroize(m) + '-' + zeroize(d);
        } else {
            var newDate = new Date((curTimestamp - 86400)); // 参数中的时间戳加一天转换成的日期对象
            if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
                return '昨天' + '&nbsp;&nbsp;&nbsp;&nbsp;' + Y + '-' + zeroize(m) + '-' + zeroize(d);
            } else {
                return Y + '-' + zeroize(m) + '-' + zeroize(d);
            }
        }
    } else {
        if (timestampDiff < 60) { // 一分钟以内
            return "刚刚";
        } else{ // 一小时前之内
            return zeroize(H) + ':' + zeroize(i);
        }

        // else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
        //     return '今天' + zeroize(H) + ':' + zeroize(i);
        // } else {
        //     var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
        //     if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
        //         return '昨天' + zeroize(H) + ':' + zeroize(i);
        //     } else {
        //         return Y + '年' + zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
        //     }
        // }
    }


}
export function timeLine(params, time) {
    let newArr = [];
    params.forEach(element => {
        element.nowTime = timestampFormat(element[time], 'top')
        element.samllTime = timestampFormat(element[time])
        let timeitem = transDate(element[time]);
        element.time = timeitem;

    });
    params.forEach((address, i) => {
        let index = -1;
        let alreadyExists = newArr.some((newAddress, j) => {
            if (address.time === newAddress.time) {
                index = j;
                return true;
            }
        });
        if (!alreadyExists) {
            let location = [];
            location.push(address)
            newArr.push({
                time: address.time,
                nowTime: address.nowTime,
                location: location
            });
        } else {
            newArr[index].location.push(address);
        }
    });
    return newArr;
}